import { STATIC_SHELL_SPLASH_ID } from './shellSplashConstants'

export function dismissStaticShellSplash(): void {
  document.getElementById(STATIC_SHELL_SPLASH_ID)?.remove()
}
